export default [
  {
    path: '/chatwoot/conversaciones',
    name: 'chatwoot-conversaciones',
    component: () => import(/* webpackChunkName: "chatwoot-conversaciones" */
      '@/pages/chatwoot/ChatwootConversacionesPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/chatwoot/conversaciones/:id',
    name: 'chatwoot-conversacion-detalle',
    component: () => import(/* webpackChunkName: "chatwoot-conversacion-detalle" */
      '@/pages/chatwoot/ChatwootConversacionDetallePage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/chatwoot/configuracion',
    name: 'chatwoot-configuracion',
    component: () => import(/* webpackChunkName: "chatwoot-configuracion" */
      '@/pages/chatwoot/ChatwootConfigPage.vue'),
    meta: { requiresAuth: true }
  }
]
